module.exports = __webpack_public_path__ + "static/15-72ec63303988ec5547b73fc9a1b4d94d.jpg";